import { Pencil1Icon, PlusIcon, TrashIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { ConfirmAlertDialog } from '../../../components/common/ConfirmAlertDialog';
import { Lists } from '../../../components/common/Lists';
import TableComponent from '../../../components/common/Tables';
import { useAppDispatch } from '../../../hooks/hooks';
import { useGetAuthorsQuery } from '../../../hooks/library/useGetAuthorsQuery';
import { setAuthorData } from '../../../redux/slices/library/author';
import { routes } from '../../../routes';
import { updateAuthor } from '../../../services/library/author';
import { AuthorType } from '../../../types/Library';
import { key_authors } from '../../../utils/constants';
import { setPreviousPath } from '../../../redux/slices/previousPath';

const columnNamesMap: { [key: string]: string } = {
    fullname: 'Nome',
};

export const Authors = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteItem, setDeleteItem] = useState<AuthorType | null>(null);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const { data, status } = useGetAuthorsQuery({ PageNumber: currentPage, PageSize: 10 });
    const mutationUpdate = useMutation(updateAuthor, {
        onSuccess: () => {
            queryClient.invalidateQueries(key_authors);
            toast.success('Autor eliminado');
        },
        onError: () => {
            toast.error("Erro ao eliminar o autor.")
        }
    });
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createAuthor);
    }
    const handleDelete = (c: AuthorType) => {
        c.status = false;
        mutationUpdate.mutateAsync(c)
      };
      const openDeleteDialog = (s: AuthorType) => {
        setDeleteItem(s);
      };  
      const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem!)
        }
      };
      const handleEdit = (c: AuthorType) => {
        dispatch(setAuthorData(c));
        navigate(routes.updateAuthor)
      };
      const handleAddBooks = (c: AuthorType) => {
        dispatch(setAuthorData(c));
        dispatch(setPreviousPath(routes.authors));
        navigate(routes.manageBookAuthors)
      };

      const options = data?.items.map((c: AuthorType) => [
        {
            label: 'Editar',
            onClick: () => handleEdit(c),
            icon: <Pencil1Icon />
        },
        {
            label: 'Adicionar livros',
            onClick: () => handleAddBooks(c),
            icon: <PlusIcon />
        },
        {
            label: 'Eliminar',
            onClick: () => openDeleteDialog(c),
            icon: <TrashIcon />
        }
      ]) || [];
      return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        emptyMessage="Ainda não existem autores registados."
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                description="O autor deixará de estar disponível na biblioteca. Pretende continuar?"
                confirmLabel="Eliminar"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
      );
}
